import React from 'react';

// Hooks
import usePressEvents from "../../hooks/ui/usePressEvents";

// Components
import CarouselSection from "../../components/carousel-section";

function PressEvents() {
  const { sections } = usePressEvents();
  return (
    <main>
      {
        sections.map((item, idx) => {

          const { title, accentColor, backgroundColor, sliderItems} = item.fields;
          return (
              <CarouselSection
              key={idx}
              idx={idx}
              title={title}
              accentColor={accentColor}
              backgroundColor={backgroundColor}
              sliderItems={sliderItems} />
          )
        })
      }
    </main>
  );
}

export default PressEvents;
